class TypingAnimation {
    constructor(animationElement) {
        this.animationElement = animationElement // Element used for observer
        this.animationSpeed = this.getAnimationSpeed() // Get animation speed
        this.animationElement.classList.add('js-animation__typing--prepare') // visibility hidden
        this.addScrollIntoViewObserver() // Add IntersectionObserver
    }

    /**
     * @private
     * Add IntersectionObserver to start animation when element is in view
     */
    addScrollIntoViewObserver() {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Set minimum height based on content height
                        const contentHeight = this.animationElement.scrollHeight
                        this.animationElement.style.minHeight = contentHeight + 'px'
                        // Add class to start animation
                        this.animationElement.classList.add('js-animation__typing--start')
                        this.typing(this.animationElement, this.animationSpeed)
                        setTimeout(() => {
                            observer.unobserve(entry.target)
                        }, 25)
                    }
                })
            },
            {
                root: null, // Use the viewport as the root
                threshold: 1, // Trigger when 100% of the target is visible
                rootMargin: '-100px 0px -100px 0px', // No margin around the root
            } // Adjust root margin as needed
        )
        observer.observe(this.animationElement)
    }

    /**
     * @private
     * Extract animation speed from class name
     */
    getAnimationSpeed() {
        const className = this.animationElement.className
        const match = className.match(/js__animation--typing-(\d+)/) // Extract number
        if (match) {
            return parseInt(match[1]) // Return the extracted number
        }
    }

    /**
     * @private
     * Simulate typing effect
     */
    typing(htmlElementToWrite, animationSpeed) {
        function setupTypewriter(t) {
            //add Time delay so the | does not show up to early
            setTimeout(function () {
                const element = document.querySelector('.main-content')
                element.classList.add('js-animation__typing-ready')
            }, 1000)

            // Setup typewriter effect
            const HTML = t.innerHTML
            t.innerHTML = ''
            t.style.opacity = '1'
            t.classList.remove('js-animation__typing--prepare')
            let cursorPosition = 0,
                tag = '',
                writingTag = false,
                tagOpen = false,
                typeSpeed = animationSpeed,
                tempTypeSpeed = 0

            const type = function () {
                // Typewriter animation logic

                // If currently typing a tag
                if (writingTag === true) {
                    tag += HTML[cursorPosition]
                }

                // If encountered a '<' symbol (start of HTML tag)
                if (HTML[cursorPosition] === '<') {
                    tempTypeSpeed = 0 // No delay for typing HTML tags
                    if (tagOpen) {
                        // If already in a tag, close it and start typing again
                        tagOpen = false
                        writingTag = true
                    } else {
                        // If not in a tag, start a new tag
                        tag = ''
                        tagOpen = true
                        writingTag = true
                        tag += HTML[cursorPosition]
                    }
                }

                // If currently typing a tag and not a '<' symbol
                if (!writingTag && tagOpen) {
                    tag.innerHTML += HTML[cursorPosition]
                } else if (!writingTag && !tagOpen) {
                    // If not typing a tag and not in a tag, type the content
                    if (HTML[cursorPosition] === ' ') {
                        tempTypeSpeed = 0 // No delay for typing spaces
                    } else {
                        tempTypeSpeed = typeSpeed // Normal typing speed
                    }
                    t.innerHTML += HTML[cursorPosition]
                }

                // If just finished typing a tag (encountered '>')
                if (writingTag === true && HTML[cursorPosition] === '>') {
                    tempTypeSpeed = typeSpeed // Resume normal typing speed
                    writingTag = false
                    if (tagOpen) {
                        // If in a tag, close it and append to the content
                        const newSpan = document.createElement('span')
                        t.appendChild(newSpan)
                        newSpan.innerHTML = tag
                        tag = newSpan.firstChild
                    }
                }

                cursorPosition += 1 // Move to the next character

                // Continue typing until the end of the content
                if (cursorPosition < HTML.length) {
                    // If it's a tag, set timeout duration to 0
                    const timeoutDuration = HTML[cursorPosition] === '<' ? 0 : tempTypeSpeed
                    setTimeout(type, timeoutDuration)
                } else {
                    // Reset to original content and styling
                    t.innerHTML = HTML
                    t.classList.remove('js-animation__typing--start')
                    t.style.minHeight = ''
                }
            }

            return { type: type }
        }

        let typewriter = setupTypewriter(htmlElementToWrite)

        setTimeout(() => {
            typewriter.type() // Start typing animation
        }, 500)
    }
}

export default function initTypingAnimations() {
    // Check if it's the Neos backend
    if (document.querySelector('body.neos-backend')) return false

    // Select elements with class containing "js__animation--typing"
    const typingAnimations = document.querySelectorAll('[class*="js__animation--typing"]')

    // Initialize TypingAnimation for each selected element
    typingAnimations.forEach((animationElement) => {
        new TypingAnimation(animationElement)
    })
}
